var ue = Object.getOwnPropertySymbols;
var nn = Object.prototype.hasOwnProperty, rn = Object.prototype.propertyIsEnumerable;
var ce = (n, t) => {
  var e = {};
  for (var r in n)
    nn.call(n, r) && t.indexOf(r) < 0 && (e[r] = n[r]);
  if (n != null && ue)
    for (var r of ue(n))
      t.indexOf(r) < 0 && rn.call(n, r) && (e[r] = n[r]);
  return e;
};
import on, { useMemo as gt } from "react";
import { useField as an, useFormikContext as sn } from "formik";
var je = { exports: {} }, At = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var un = on, cn = Symbol.for("react.element"), ln = Symbol.for("react.fragment"), dn = Object.prototype.hasOwnProperty, fn = un.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, hn = { key: !0, ref: !0, __self: !0, __source: !0 };
function Ae(n, t, e) {
  var r, o = {}, i = null, a = null;
  e !== void 0 && (i = "" + e), t.key !== void 0 && (i = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t)
    dn.call(t, r) && !hn.hasOwnProperty(r) && (o[r] = t[r]);
  if (n && n.defaultProps)
    for (r in t = n.defaultProps, t)
      o[r] === void 0 && (o[r] = t[r]);
  return { $$typeof: cn, type: n, key: i, ref: a, props: o, _owner: fn.current };
}
At.Fragment = ln;
At.jsx = Ae;
At.jsxs = Ae;
je.exports = At;
var $i = je.exports;
function De(n) {
  var t, e, r = "";
  if (typeof n == "string" || typeof n == "number")
    r += n;
  else if (typeof n == "object")
    if (Array.isArray(n)) {
      var o = n.length;
      for (t = 0; t < o; t++)
        n[t] && (e = De(n[t])) && (r && (r += " "), r += e);
    } else
      for (e in n)
        n[e] && (r && (r += " "), r += e);
  return r;
}
function Gi() {
  for (var n, t, e = 0, r = "", o = arguments.length; e < o; e++)
    (n = arguments[e]) && (t = De(n)) && (r && (r += " "), r += t);
  return r;
}
var pn = Object.defineProperty, mn = Object.defineProperties, gn = Object.getOwnPropertyDescriptors, kt = Object.getOwnPropertySymbols, Le = Object.prototype.hasOwnProperty, Ne = Object.prototype.propertyIsEnumerable, Yt = (n, t, e) => t in n ? pn(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, R = (n, t) => {
  for (var e in t || (t = {}))
    Le.call(t, e) && Yt(n, e, t[e]);
  if (kt)
    for (var e of kt(t))
      Ne.call(t, e) && Yt(n, e, t[e]);
  return n;
}, tt = (n, t) => mn(n, gn(t)), bn = (n, t) => {
  var e = {};
  for (var r in n)
    Le.call(n, r) && t.indexOf(r) < 0 && (e[r] = n[r]);
  if (n != null && kt)
    for (var r of kt(n))
      t.indexOf(r) < 0 && Ne.call(n, r) && (e[r] = n[r]);
  return e;
}, h = (n, t, e) => (Yt(n, typeof t != "symbol" ? t + "" : t, e), e), nt = (n, t, e) => new Promise((r, o) => {
  var i = (c) => {
    try {
      u(e.next(c));
    } catch (s) {
      o(s);
    }
  }, a = (c) => {
    try {
      u(e.throw(c));
    } catch (s) {
      o(s);
    }
  }, u = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
  u((e = e.apply(n, t)).next());
}), Z = /* @__PURE__ */ ((n) => (n.ESHOP_AVAILABLEINESHOP = "ESHOP_AVAILABLEINESHOP", n.ESHOP_AVAILABLEOUTSIDEESHOP = "ESHOP_AVAILABLEOUTSIDEESHOP", n.ESHOP_UNAVAILABLE = "ESHOP_UNAVAILABLE", n.SHOP_AVAILABLE = "SHOP_AVAILABLE", n.SHOP_AVAILABLEINESHOP = "SHOP_AVAILABLEINESHOP", n.SHOP_AVAILABLEOUTSIDEESHOP = "SHOP_AVAILABLEOUTSIDEESHOP", n.SHOP_UNAVAILABLE = "SHOP_UNAVAILABLE", n))(Z || {});
const Qi = ({
  selectedOrganization: n = "",
  selectedOrganizationStockId: t = "",
  stockAvailability: e = [],
  stockAvailabilitySummary: r = "unavailable"
}) => {
  if (!n || !t)
    switch (r) {
      case "availableInEshop":
        return Z.ESHOP_AVAILABLEINESHOP;
      case "availableOutsideEshop":
        return Z.ESHOP_AVAILABLEOUTSIDEESHOP;
      default:
        return Z.ESHOP_UNAVAILABLE;
    }
  if (e && e.find(
    ({ availableAmount: o, stockIdentifier: i }) => i === t && o > 0
  ))
    return Z.SHOP_AVAILABLE;
  switch (r) {
    case "availableInEshop":
      return Z.SHOP_AVAILABLEINESHOP;
    case "availableOutsideEshop":
      return Z.SHOP_AVAILABLEOUTSIDEESHOP;
    default:
      return Z.SHOP_UNAVAILABLE;
  }
}, Re = 6048e5, yn = 864e5, wn = 6e4, vn = 36e5, xn = 1e3, le = Symbol.for("constructDateFrom");
function _(n, t) {
  return typeof n == "function" ? n(t) : n && typeof n == "object" && le in n ? n[le](t) : n instanceof Date ? new n.constructor(t) : new Date(t);
}
function q(n, t) {
  return _(t || n, n);
}
function qe(n, t, e) {
  const r = q(n, e == null ? void 0 : e.in);
  return isNaN(t) ? _((e == null ? void 0 : e.in) || n, NaN) : (t && r.setDate(r.getDate() + t), r);
}
let On = {};
function Ot() {
  return On;
}
function K(n, t) {
  var e, r, o, i, a, u, c, s;
  const f = Ot(), p = (s = (c = (i = (o = t == null ? void 0 : t.weekStartsOn) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.weekStartsOn) != null ? i : f.weekStartsOn) != null ? c : (u = (a = f.locale) == null ? void 0 : a.options) == null ? void 0 : u.weekStartsOn) != null ? s : 0, b = q(n, t == null ? void 0 : t.in), y = b.getDay(), w = (y < p ? 7 : 0) + y - p;
  return b.setDate(b.getDate() - w), b.setHours(0, 0, 0, 0), b;
}
function ht(n, t) {
  return K(n, tt(R({}, t), { weekStartsOn: 1 }));
}
function Ie(n, t) {
  const e = q(n, t == null ? void 0 : t.in), r = e.getFullYear(), o = _(e, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = ht(o), a = _(e, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const u = ht(a);
  return e.getTime() >= i.getTime() ? r + 1 : e.getTime() >= u.getTime() ? r : r - 1;
}
function St(n) {
  const t = q(n), e = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return e.setUTCFullYear(t.getFullYear()), +n - +e;
}
function He(n, ...t) {
  const e = _.bind(
    null,
    n || t.find((r) => typeof r == "object")
  );
  return t.map(e);
}
function de(n, t) {
  const e = q(n, t == null ? void 0 : t.in);
  return e.setHours(0, 0, 0, 0), e;
}
function Pn(n, t, e) {
  const [r, o] = He(
    e == null ? void 0 : e.in,
    n,
    t
  ), i = de(r), a = de(o), u = +i - St(i), c = +a - St(a);
  return Math.round((u - c) / yn);
}
function kn(n, t) {
  const e = Ie(n, t), r = _((t == null ? void 0 : t.in) || n, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), ht(r);
}
function Sn(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function En(n) {
  return !(!Sn(n) && typeof n != "number" || isNaN(+q(n)));
}
function Tn(n, t) {
  const e = q(n, t == null ? void 0 : t.in);
  return e.setFullYear(e.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
const Mn = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, jn = (n, t, e) => {
  let r;
  const o = Mn[n];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ct(n) {
  return (t = {}) => {
    const e = t.width ? String(t.width) : n.defaultWidth;
    return n.formats[e] || n.formats[n.defaultWidth];
  };
}
const An = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Dn = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ln = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Nn = {
  date: ct({
    formats: An,
    defaultWidth: "full"
  }),
  time: ct({
    formats: Dn,
    defaultWidth: "full"
  }),
  dateTime: ct({
    formats: Ln,
    defaultWidth: "full"
  })
}, Rn = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, qn = (n, t, e, r) => Rn[n];
function Q(n) {
  return (t, e) => {
    const r = e != null && e.context ? String(e.context) : "standalone";
    let o;
    if (r === "formatting" && n.formattingValues) {
      const a = n.defaultFormattingWidth || n.defaultWidth, u = e != null && e.width ? String(e.width) : a;
      o = n.formattingValues[u] || n.formattingValues[a];
    } else {
      const a = n.defaultWidth, u = e != null && e.width ? String(e.width) : n.defaultWidth;
      o = n.values[u] || n.values[a];
    }
    const i = n.argumentCallback ? n.argumentCallback(t) : t;
    return o[i];
  };
}
const In = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Hn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, _n = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Wn = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Fn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Cn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Bn = (n, t) => {
  const e = Number(n), r = e % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, Yn = {
  ordinalNumber: Bn,
  era: Q({
    values: In,
    defaultWidth: "wide"
  }),
  quarter: Q({
    values: Hn,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: Q({
    values: _n,
    defaultWidth: "wide"
  }),
  day: Q({
    values: Wn,
    defaultWidth: "wide"
  }),
  dayPeriod: Q({
    values: Fn,
    defaultWidth: "wide",
    formattingValues: Cn,
    defaultFormattingWidth: "wide"
  })
};
function V(n) {
  return (t, e = {}) => {
    const r = e.width, o = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], u = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], c = Array.isArray(u) ? Gn(u, (p) => p.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      $n(u, (p) => p.test(a))
    );
    let s;
    s = n.valueCallback ? n.valueCallback(c) : c, s = e.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      e.valueCallback(s)
    ) : s;
    const f = t.slice(a.length);
    return { value: s, rest: f };
  };
}
function $n(n, t) {
  for (const e in n)
    if (Object.prototype.hasOwnProperty.call(n, e) && t(n[e]))
      return e;
}
function Gn(n, t) {
  for (let e = 0; e < n.length; e++)
    if (t(n[e]))
      return e;
}
function _e(n) {
  return (t, e = {}) => {
    const r = t.match(n.matchPattern);
    if (!r)
      return null;
    const o = r[0], i = t.match(n.parsePattern);
    if (!i)
      return null;
    let a = n.valueCallback ? n.valueCallback(i[0]) : i[0];
    a = e.valueCallback ? e.valueCallback(a) : a;
    const u = t.slice(o.length);
    return { value: a, rest: u };
  };
}
const Qn = /^(\d+)(th|st|nd|rd)?/i, Vn = /\d+/i, zn = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Xn = {
  any: [/^b/i, /^(a|c)/i]
}, Un = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Kn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Jn = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Zn = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, tr = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, er = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, nr = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, rr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, or = {
  ordinalNumber: _e({
    matchPattern: Qn,
    parsePattern: Vn,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: V({
    matchPatterns: zn,
    defaultMatchWidth: "wide",
    parsePatterns: Xn,
    defaultParseWidth: "any"
  }),
  quarter: V({
    matchPatterns: Un,
    defaultMatchWidth: "wide",
    parsePatterns: Kn,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: V({
    matchPatterns: Jn,
    defaultMatchWidth: "wide",
    parsePatterns: Zn,
    defaultParseWidth: "any"
  }),
  day: V({
    matchPatterns: tr,
    defaultMatchWidth: "wide",
    parsePatterns: er,
    defaultParseWidth: "any"
  }),
  dayPeriod: V({
    matchPatterns: nr,
    defaultMatchWidth: "any",
    parsePatterns: rr,
    defaultParseWidth: "any"
  })
}, ir = {
  code: "en-US",
  formatDistance: jn,
  formatLong: Nn,
  formatRelative: qn,
  localize: Yn,
  match: or,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ar(n, t) {
  const e = q(n, t == null ? void 0 : t.in);
  return Pn(e, Tn(e)) + 1;
}
function We(n, t) {
  const e = q(n, t == null ? void 0 : t.in), r = +ht(e) - +kn(e);
  return Math.round(r / Re) + 1;
}
function zt(n, t) {
  var e, r, o, i, a, u, c, s;
  const f = q(n, t == null ? void 0 : t.in), p = f.getFullYear(), b = Ot(), y = (s = (c = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : b.firstWeekContainsDate) != null ? c : (u = (a = b.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) != null ? s : 1, w = _((t == null ? void 0 : t.in) || n, 0);
  w.setFullYear(p + 1, 0, y), w.setHours(0, 0, 0, 0);
  const P = K(w, t), S = _((t == null ? void 0 : t.in) || n, 0);
  S.setFullYear(p, 0, y), S.setHours(0, 0, 0, 0);
  const l = K(S, t);
  return +f >= +P ? p + 1 : +f >= +l ? p : p - 1;
}
function sr(n, t) {
  var e, r, o, i, a, u, c, s;
  const f = Ot(), p = (s = (c = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (e = t == null ? void 0 : t.locale) == null ? void 0 : e.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : f.firstWeekContainsDate) != null ? c : (u = (a = f.locale) == null ? void 0 : a.options) == null ? void 0 : u.firstWeekContainsDate) != null ? s : 1, b = zt(n, t), y = _((t == null ? void 0 : t.in) || n, 0);
  return y.setFullYear(b, 0, p), y.setHours(0, 0, 0, 0), K(y, t);
}
function Fe(n, t) {
  const e = q(n, t == null ? void 0 : t.in), r = +K(e, t) - +sr(e, t);
  return Math.round(r / Re) + 1;
}
function k(n, t) {
  const e = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(t, "0");
  return e + r;
}
const J = {
  // Year
  y(n, t) {
    const e = n.getFullYear(), r = e > 0 ? e : 1 - e;
    return k(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(n, t) {
    const e = n.getMonth();
    return t === "M" ? String(e + 1) : k(e + 1, 2);
  },
  // Day of the month
  d(n, t) {
    return k(n.getDate(), t.length);
  },
  // AM or PM
  a(n, t) {
    const e = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, t) {
    return k(n.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(n, t) {
    return k(n.getHours(), t.length);
  },
  // Minute
  m(n, t) {
    return k(n.getMinutes(), t.length);
  },
  // Second
  s(n, t) {
    return k(n.getSeconds(), t.length);
  },
  // Fraction of second
  S(n, t) {
    const e = t.length, r = n.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, e - 3)
    );
    return k(o, t.length);
  }
}, ut = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, fe = {
  // Era
  G: function(n, t, e) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return e.era(r, { width: "abbreviated" });
      case "GGGGG":
        return e.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return e.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, t, e) {
    if (t === "yo") {
      const r = n.getFullYear(), o = r > 0 ? r : 1 - r;
      return e.ordinalNumber(o, { unit: "year" });
    }
    return J.y(n, t);
  },
  // Local week-numbering year
  Y: function(n, t, e, r) {
    const o = zt(n, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return k(a, 2);
    }
    return t === "Yo" ? e.ordinalNumber(i, { unit: "year" }) : k(i, t.length);
  },
  // ISO week-numbering year
  R: function(n, t) {
    const e = Ie(n);
    return k(e, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, t) {
    const e = n.getFullYear();
    return k(e, t.length);
  },
  // Quarter
  Q: function(n, t, e) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return k(r, 2);
      case "Qo":
        return e.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return e.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return e.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return e.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, t, e) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return k(r, 2);
      case "qo":
        return e.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return e.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return e.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return e.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, t, e) {
    const r = n.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return J.M(n, t);
      case "Mo":
        return e.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return e.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return e.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return e.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, t, e) {
    const r = n.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return k(r + 1, 2);
      case "Lo":
        return e.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return e.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return e.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return e.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, t, e, r) {
    const o = Fe(n, r);
    return t === "wo" ? e.ordinalNumber(o, { unit: "week" }) : k(o, t.length);
  },
  // ISO week of year
  I: function(n, t, e) {
    const r = We(n);
    return t === "Io" ? e.ordinalNumber(r, { unit: "week" }) : k(r, t.length);
  },
  // Day of the month
  d: function(n, t, e) {
    return t === "do" ? e.ordinalNumber(n.getDate(), { unit: "date" }) : J.d(n, t);
  },
  // Day of year
  D: function(n, t, e) {
    const r = ar(n);
    return t === "Do" ? e.ordinalNumber(r, { unit: "dayOfYear" }) : k(r, t.length);
  },
  // Day of week
  E: function(n, t, e) {
    const r = n.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return e.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return e.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return e.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return e.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, t, e, r) {
    const o = n.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return k(i, 2);
      case "eo":
        return e.ordinalNumber(i, { unit: "day" });
      case "eee":
        return e.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return e.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return e.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return e.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, t, e, r) {
    const o = n.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return k(i, t.length);
      case "co":
        return e.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return e.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return e.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return e.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return e.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, t, e) {
    const r = n.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return k(o, t.length);
      case "io":
        return e.ordinalNumber(o, { unit: "day" });
      case "iii":
        return e.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return e.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return e.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return e.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, t, e) {
    const r = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, t, e) {
    const r = n.getHours();
    let o;
    switch (r === 12 ? o = ut.noon : r === 0 ? o = ut.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, t, e) {
    const r = n.getHours();
    let o;
    switch (r >= 17 ? o = ut.evening : r >= 12 ? o = ut.afternoon : r >= 4 ? o = ut.morning : o = ut.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, t, e) {
    if (t === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), e.ordinalNumber(r, { unit: "hour" });
    }
    return J.h(n, t);
  },
  // Hour [0-23]
  H: function(n, t, e) {
    return t === "Ho" ? e.ordinalNumber(n.getHours(), { unit: "hour" }) : J.H(n, t);
  },
  // Hour [0-11]
  K: function(n, t, e) {
    const r = n.getHours() % 12;
    return t === "Ko" ? e.ordinalNumber(r, { unit: "hour" }) : k(r, t.length);
  },
  // Hour [1-24]
  k: function(n, t, e) {
    let r = n.getHours();
    return r === 0 && (r = 24), t === "ko" ? e.ordinalNumber(r, { unit: "hour" }) : k(r, t.length);
  },
  // Minute
  m: function(n, t, e) {
    return t === "mo" ? e.ordinalNumber(n.getMinutes(), { unit: "minute" }) : J.m(n, t);
  },
  // Second
  s: function(n, t, e) {
    return t === "so" ? e.ordinalNumber(n.getSeconds(), { unit: "second" }) : J.s(n, t);
  },
  // Fraction of second
  S: function(n, t) {
    return J.S(n, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, t, e) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return pe(r);
      case "XXXX":
      case "XX":
        return rt(r);
      case "XXXXX":
      case "XXX":
      default:
        return rt(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, t, e) {
    const r = n.getTimezoneOffset();
    switch (t) {
      case "x":
        return pe(r);
      case "xxxx":
      case "xx":
        return rt(r);
      case "xxxxx":
      case "xxx":
      default:
        return rt(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, t, e) {
    const r = n.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + he(r, ":");
      case "OOOO":
      default:
        return "GMT" + rt(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, t, e) {
    const r = n.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + he(r, ":");
      case "zzzz":
      default:
        return "GMT" + rt(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, t, e) {
    const r = Math.trunc(+n / 1e3);
    return k(r, t.length);
  },
  // Milliseconds timestamp
  T: function(n, t, e) {
    return k(+n, t.length);
  }
};
function he(n, t = "") {
  const e = n > 0 ? "-" : "+", r = Math.abs(n), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? e + String(o) : e + String(o) + t + k(i, 2);
}
function pe(n, t) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + k(Math.abs(n) / 60, 2) : rt(n, t);
}
function rt(n, t = "") {
  const e = n > 0 ? "-" : "+", r = Math.abs(n), o = k(Math.trunc(r / 60), 2), i = k(r % 60, 2);
  return e + o + t + i;
}
const me = (n, t) => {
  switch (n) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Ce = (n, t) => {
  switch (n) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ur = (n, t) => {
  const e = n.match(/(P+)(p+)?/) || [], r = e[1], o = e[2];
  if (!o)
    return me(n, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", me(r, t)).replace("{{time}}", Ce(o, t));
}, cr = {
  p: Ce,
  P: ur
}, lr = /^D+$/, dr = /^Y+$/, fr = ["D", "DD", "YY", "YYYY"];
function hr(n) {
  return lr.test(n);
}
function pr(n) {
  return dr.test(n);
}
function mr(n, t, e) {
  const r = gr(n, t, e);
  if (console.warn(r), fr.includes(n))
    throw new RangeError(r);
}
function gr(n, t, e) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${t}\`) for formatting ${r} to the input \`${e}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const br = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, yr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, wr = /^'([^]*?)'?$/, vr = /''/g, xr = /[a-zA-Z]/;
function Or(n, t, e) {
  var r, o, i, a, u, c, s, f, p, b, y, w, P, S, l, d, m, g;
  const v = Ot(), H = (o = (r = e == null ? void 0 : e.locale) != null ? r : v.locale) != null ? o : ir, I = (b = (p = (c = (u = e == null ? void 0 : e.firstWeekContainsDate) != null ? u : (a = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : a.firstWeekContainsDate) != null ? c : v.firstWeekContainsDate) != null ? p : (f = (s = v.locale) == null ? void 0 : s.options) == null ? void 0 : f.firstWeekContainsDate) != null ? b : 1, C = (g = (m = (S = (P = e == null ? void 0 : e.weekStartsOn) != null ? P : (w = (y = e == null ? void 0 : e.locale) == null ? void 0 : y.options) == null ? void 0 : w.weekStartsOn) != null ? S : v.weekStartsOn) != null ? m : (d = (l = v.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) != null ? g : 0, A = q(n, e == null ? void 0 : e.in);
  if (!En(A))
    throw new RangeError("Invalid time value");
  let N = t.match(yr).map((M) => {
    const O = M[0];
    if (O === "p" || O === "P") {
      const W = cr[O];
      return W(M, H.formatLong);
    }
    return M;
  }).join("").match(br).map((M) => {
    if (M === "''")
      return { isToken: !1, value: "'" };
    const O = M[0];
    if (O === "'")
      return { isToken: !1, value: Pr(M) };
    if (fe[O])
      return { isToken: !0, value: M };
    if (O.match(xr))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + O + "`"
      );
    return { isToken: !1, value: M };
  });
  H.localize.preprocessor && (N = H.localize.preprocessor(A, N));
  const B = {
    firstWeekContainsDate: I,
    weekStartsOn: C,
    locale: H
  };
  return N.map((M) => {
    if (!M.isToken)
      return M.value;
    const O = M.value;
    (!(e != null && e.useAdditionalWeekYearTokens) && pr(O) || !(e != null && e.useAdditionalDayOfYearTokens) && hr(O)) && mr(O, t, String(n));
    const W = fe[O[0]];
    return W(A, O, H.localize, B);
  }).join("");
}
function Pr(n) {
  const t = n.match(wr);
  return t ? t[1].replace(vr, "'") : n;
}
function kr(n, t) {
  const e = q(n, t == null ? void 0 : t.in).getDay();
  return e === 0 ? 7 : e;
}
class Sr {
  constructor() {
    h(this, "subPriority", 0);
  }
  validate(t, e) {
    return !0;
  }
}
class Er extends Sr {
  constructor(t, e, r, o, i) {
    super(), this.value = t, this.validateValue = e, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, e) {
    return this.validateValue(t, this.value, e);
  }
  set(t, e, r) {
    return this.setValue(t, e, this.value, r);
  }
}
class x {
  run(t, e, r, o) {
    const i = this.parse(t, e, r, o);
    return i ? {
      setter: new Er(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, e, r) {
    return !0;
  }
}
class Tr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 140), h(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, e, r) {
    return e.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const D = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, z = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function L(n, t) {
  return n && {
    value: t(n.value),
    rest: n.rest
  };
}
function T(n, t) {
  const e = t.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: t.slice(e[0].length)
  } : null;
}
function X(n, t) {
  const e = t.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = e[1] === "+" ? 1 : -1, o = e[2] ? parseInt(e[2], 10) : 0, i = e[3] ? parseInt(e[3], 10) : 0, a = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (o * vn + i * wn + a * xn),
    rest: t.slice(e[0].length)
  };
}
function Be(n) {
  return T(D.anyDigitsSigned, n);
}
function j(n, t) {
  switch (n) {
    case 1:
      return T(D.singleDigit, t);
    case 2:
      return T(D.twoDigits, t);
    case 3:
      return T(D.threeDigits, t);
    case 4:
      return T(D.fourDigits, t);
    default:
      return T(new RegExp("^\\d{1," + n + "}"), t);
  }
}
function Ye(n, t) {
  switch (n) {
    case 1:
      return T(D.singleDigitSigned, t);
    case 2:
      return T(D.twoDigitsSigned, t);
    case 3:
      return T(D.threeDigitsSigned, t);
    case 4:
      return T(D.fourDigitsSigned, t);
    default:
      return T(new RegExp("^-?\\d{1," + n + "}"), t);
  }
}
function Xt(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function $e(n, t) {
  const e = t > 0, r = e ? t : 1 - t;
  let o;
  if (r <= 50)
    o = n || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, u = n >= i % 100;
    o = n + a - (u ? 100 : 0);
  }
  return e ? o : 1 - o;
}
function Ge(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class Mr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 130), h(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return L(j(4, t), o);
      case "yo":
        return L(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return L(j(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r) {
    const o = t.getFullYear();
    if (r.isTwoDigitYear) {
      const a = $e(
        r.year,
        o
      );
      return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class jr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 130), h(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return L(j(4, t), o);
      case "Yo":
        return L(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return L(j(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r, o) {
    const i = zt(t, o);
    if (r.isTwoDigitYear) {
      const u = $e(
        r.year,
        i
      );
      return t.setFullYear(
        u,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), K(t, o);
    }
    const a = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(a, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), K(t, o);
  }
}
class Ar extends x {
  constructor() {
    super(...arguments), h(this, "priority", 130), h(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e) {
    return Ye(e === "R" ? 4 : e.length, t);
  }
  set(t, e, r) {
    const o = _(t, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), ht(o);
  }
}
class Dr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 130), h(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return Ye(e === "u" ? 4 : e.length, t);
  }
  set(t, e, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Lr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 120), h(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "Q":
      case "QQ":
        return j(e.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Nr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 120), h(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "q":
      case "qq":
        return j(e.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Rr extends x {
  constructor() {
    super(...arguments), h(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), h(this, "priority", 110);
  }
  parse(t, e, r) {
    const o = (i) => i - 1;
    switch (e) {
      case "M":
        return L(
          T(D.month, t),
          o
        );
      case "MM":
        return L(j(2, t), o);
      case "Mo":
        return L(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class qr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 110), h(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => i - 1;
    switch (e) {
      case "L":
        return L(
          T(D.month, t),
          o
        );
      case "LL":
        return L(j(2, t), o);
      case "Lo":
        return L(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Ir(n, t, e) {
  const r = q(n, e == null ? void 0 : e.in), o = Fe(r, e) - t;
  return r.setDate(r.getDate() - o * 7), q(r, e == null ? void 0 : e.in);
}
class Hr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 100), h(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "w":
        return T(D.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r, o) {
    return K(Ir(t, r, o), o);
  }
}
function _r(n, t, e) {
  const r = q(n, e == null ? void 0 : e.in), o = We(r, e) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class Wr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 100), h(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "I":
        return T(D.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r) {
    return ht(_r(t, r));
  }
}
const Fr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Cr = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Br extends x {
  constructor() {
    super(...arguments), h(this, "priority", 90), h(this, "subPriority", 1), h(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "d":
        return T(D.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear(), o = Ge(r), i = t.getMonth();
    return o ? e >= 1 && e <= Cr[i] : e >= 1 && e <= Fr[i];
  }
  set(t, e, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class Yr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 90), h(this, "subpriority", 1), h(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return T(D.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear();
    return Ge(r) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function Ut(n, t, e) {
  var r, o, i, a, u, c, s, f;
  const p = Ot(), b = (f = (s = (a = (i = e == null ? void 0 : e.weekStartsOn) != null ? i : (o = (r = e == null ? void 0 : e.locale) == null ? void 0 : r.options) == null ? void 0 : o.weekStartsOn) != null ? a : p.weekStartsOn) != null ? s : (c = (u = p.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) != null ? f : 0, y = q(n, e == null ? void 0 : e.in), w = y.getDay(), P = (t % 7 + 7) % 7, S = 7 - b, l = t < 0 || t > 6 ? t - (w + S) % 7 : (P + S) % 7 - (w + S) % 7;
  return qe(y, l, e);
}
class $r extends x {
  constructor() {
    super(...arguments), h(this, "priority", 90), h(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Ut(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Gr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 90), h(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const i = (a) => {
      const u = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + u;
    };
    switch (e) {
      case "e":
      case "ee":
        return L(j(e.length, t), i);
      case "eo":
        return L(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Ut(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Qr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 90), h(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const i = (a) => {
      const u = Math.floor((a - 1) / 7) * 7;
      return (a + o.weekStartsOn + 6) % 7 + u;
    };
    switch (e) {
      case "c":
      case "cc":
        return L(j(e.length, t), i);
      case "co":
        return L(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = Ut(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
function Vr(n, t, e) {
  const r = q(n, e == null ? void 0 : e.in), o = kr(r, e), i = t - o;
  return qe(r, i, e);
}
class zr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 90), h(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (i) => i === 0 ? 7 : i;
    switch (e) {
      case "i":
      case "ii":
        return j(e.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return L(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return L(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return L(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return L(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, r) {
    return t = Vr(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class Xr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 80), h(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Xt(r), 0, 0, 0), t;
  }
}
class Ur extends x {
  constructor() {
    super(...arguments), h(this, "priority", 80), h(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Xt(r), 0, 0, 0), t;
  }
}
class Kr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 80), h(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(Xt(r), 0, 0, 0), t;
  }
}
class Jr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 70), h(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "h":
        return T(D.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, r) {
    const o = t.getHours() >= 12;
    return o && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class Zr extends x {
  constructor() {
    super(...arguments), h(this, "priority", 70), h(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "H":
        return T(D.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class to extends x {
  constructor() {
    super(...arguments), h(this, "priority", 70), h(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "K":
        return T(D.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class eo extends x {
  constructor() {
    super(...arguments), h(this, "priority", 70), h(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "k":
        return T(D.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, r) {
    const o = r <= 24 ? r % 24 : r;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class no extends x {
  constructor() {
    super(...arguments), h(this, "priority", 60), h(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "m":
        return T(D.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class ro extends x {
  constructor() {
    super(...arguments), h(this, "priority", 50), h(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "s":
        return T(D.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return j(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setSeconds(r, 0), t;
  }
}
class oo extends x {
  constructor() {
    super(...arguments), h(this, "priority", 30), h(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    const r = (o) => Math.trunc(o * Math.pow(10, -e.length + 3));
    return L(j(e.length, t), r);
  }
  set(t, e, r) {
    return t.setMilliseconds(r), t;
  }
}
class io extends x {
  constructor() {
    super(...arguments), h(this, "priority", 10), h(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return X(
          z.basicOptionalMinutes,
          t
        );
      case "XX":
        return X(z.basic, t);
      case "XXXX":
        return X(
          z.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return X(
          z.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return X(z.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : _(
      t,
      t.getTime() - St(t) - r
    );
  }
}
class ao extends x {
  constructor() {
    super(...arguments), h(this, "priority", 10), h(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return X(
          z.basicOptionalMinutes,
          t
        );
      case "xx":
        return X(z.basic, t);
      case "xxxx":
        return X(
          z.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return X(
          z.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return X(z.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : _(
      t,
      t.getTime() - St(t) - r
    );
  }
}
class so extends x {
  constructor() {
    super(...arguments), h(this, "priority", 40), h(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Be(t);
  }
  set(t, e, r) {
    return [_(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class uo extends x {
  constructor() {
    super(...arguments), h(this, "priority", 20), h(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Be(t);
  }
  set(t, e, r) {
    return [_(t, r), { timestampIsSet: !0 }];
  }
}
new Tr(), new Mr(), new jr(), new Ar(), new Dr(), new Lr(), new Nr(), new Rr(), new qr(), new Hr(), new Wr(), new Br(), new Yr(), new $r(), new Gr(), new Qr(), new zr(), new Xr(), new Ur(), new Kr(), new Jr(), new Zr(), new to(), new eo(), new no(), new ro(), new oo(), new io(), new ao(), new so(), new uo();
function ge(n, t, e) {
  const [r, o] = He(
    e == null ? void 0 : e.in,
    n,
    t
  );
  return +K(r, e) == +K(o, e);
}
function co(n) {
  return `${n.charAt(0).toUpperCase()}${n.slice(1)}`;
}
function Vi(n) {
  return n % 1 !== 0 ? n.toFixed(2).replace(".", ",") : n.toString().replace(".", ",");
}
function zi(n, t) {
  let e = n;
  for (const r in t)
    e = e.replaceAll(`$${r}$`, t[r]);
  return e;
}
const Kt = (n, t) => {
  let e = !0;
  return n.length !== t.length ? e = !1 : n.forEach((r, o) => {
    const i = pt(r), a = pt(t[o]);
    i !== a ? e = !1 : i === "object" ? Jt(r, t[o]) || (e = !1) : i === "array" ? Kt(r, t[o]) || (e = !1) : r !== t[o] && (e = !1);
  }), e;
}, Jt = (n, t) => {
  let e = !0;
  return Object.keys(n).length !== Object.keys(t).length ? e = !1 : Object.keys(n).forEach((r) => {
    const o = pt(n[r]), i = pt(t[r]);
    o !== i ? e = !1 : o === "object" ? Jt(n[r], t[r]) || (e = !1) : o === "array" ? Kt(n[r], t[r]) || (e = !1) : t[r] !== n[r] && (e = !1);
  }), e;
}, pt = (n) => {
  const t = typeof n;
  if (t === "number")
    return isNaN(n) ? "NaN" : t;
  if (t === "object") {
    if (n instanceof Array)
      return "array";
    if (n instanceof Element)
      return "node";
    if (String(n == null ? void 0 : n.$$typeof) === "Symbol(react.element)")
      return "ReactNode";
    if (n === null)
      return "null";
  }
  return t;
}, Xi = (n, t) => {
  const e = pt(n), r = pt(t);
  return e !== r ? !1 : e === "array" ? Kt(n, t) : e === "object" || e === "ReactNode" ? Jt(n, t) : e === "node" ? n.isEqualNode(t) : n === t;
}, Ui = (n, t) => n == null ? 1 : t == null ? -1 : n > t ? 1 : -1;
function lo(n, t) {
  return t === 1 && n.one ? n.one : t >= 2 && t <= 4 && n.twoFour ? n.twoFour : n.other;
}
function Rt(n, t, e) {
  return lo(n, t)[e].replace("{{count}}", String(t));
}
function fo(n) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(t) {
      return !!n.match(new RegExp("^" + t));
    }
  )[0];
}
function qt(n) {
  let t = "";
  return n === "almost" && (t = "takmer"), n === "about" && (t = "približne"), t.length > 0 ? t + " " : "";
}
function It(n) {
  let t = "";
  return n === "lessThan" && (t = "menej než"), n === "over" && (t = "viac než"), t.length > 0 ? t + " " : "";
}
function ho(n) {
  return n.charAt(0).toLowerCase() + n.slice(1);
}
const po = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, mo = (n, t, e) => {
  const r = fo(n) || "", o = ho(n.substring(r.length)), i = po[o];
  return e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? qt(r) + "o " + It(r) + Rt(i, t, "future") : qt(r) + "pred " + It(r) + Rt(i, t, "past") : qt(r) + It(r) + Rt(i, t, "present");
}, go = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, bo = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, yo = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, wo = {
  date: ct({
    formats: go,
    defaultWidth: "full"
  }),
  time: ct({
    formats: bo,
    defaultWidth: "full"
  }),
  dateTime: ct({
    formats: yo,
    defaultWidth: "full"
  })
}, Zt = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function vo(n) {
  const t = Zt[n];
  switch (n) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + t + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function be(n) {
  const t = Zt[n];
  return n === 4 ? "'vo' eeee 'o' p" : "'v " + t + " o' p";
}
function xo(n) {
  const t = Zt[n];
  switch (n) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + t + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const Oo = {
  lastWeek: (n, t, e) => {
    const r = n.getDay();
    return ge(n, t, e) ? be(r) : vo(r);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (n, t, e) => {
    const r = n.getDay();
    return ge(n, t, e) ? be(r) : xo(r);
  },
  other: "P"
}, Po = (n, t, e, r) => {
  const o = Oo[n];
  return typeof o == "function" ? o(t, e, r) : o;
}, ko = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, So = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, Eo = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, To = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, Mo = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, jo = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, Ao = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, Do = (n, t) => Number(n) + ".", Lo = {
  ordinalNumber: Do,
  era: Q({
    values: ko,
    defaultWidth: "wide"
  }),
  quarter: Q({
    values: So,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: Q({
    values: Eo,
    defaultWidth: "wide",
    formattingValues: To,
    defaultFormattingWidth: "wide"
  }),
  day: Q({
    values: Mo,
    defaultWidth: "wide"
  }),
  dayPeriod: Q({
    values: jo,
    defaultWidth: "wide",
    formattingValues: Ao,
    defaultFormattingWidth: "wide"
  })
}, No = /^(\d+)\.?/i, Ro = /\d+/i, qo = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, Io = {
  any: [/^pr/i, /^(po|n)/i]
}, Ho = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, _o = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Wo = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, Fo = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Co = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, Bo = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, Yo = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, $o = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, Go = {
  ordinalNumber: _e({
    matchPattern: No,
    parsePattern: Ro,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: V({
    matchPatterns: qo,
    defaultMatchWidth: "wide",
    parsePatterns: Io,
    defaultParseWidth: "any"
  }),
  quarter: V({
    matchPatterns: Ho,
    defaultMatchWidth: "wide",
    parsePatterns: _o,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: V({
    matchPatterns: Wo,
    defaultMatchWidth: "wide",
    parsePatterns: Fo,
    defaultParseWidth: "any"
  }),
  day: V({
    matchPatterns: Co,
    defaultMatchWidth: "wide",
    parsePatterns: Bo,
    defaultParseWidth: "any"
  }),
  dayPeriod: V({
    matchPatterns: Yo,
    defaultMatchWidth: "any",
    parsePatterns: $o,
    defaultParseWidth: "any"
  })
}, Qo = {
  code: "sk",
  formatDistance: mo,
  formatLong: wo,
  formatRelative: Po,
  localize: Lo,
  match: Go,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function Qe() {
  return process.env.LOGGER_ENV !== "PROD";
}
function Vo() {
  return process.env.LOGGER_ENV !== "PROD" && process.env.LOGGER_ENV !== "PPT";
}
class G {
  static get currentDate() {
    const t = (s) => s < 10 ? `0${s}` : `${s}`, e = new Date(Date.now()), r = t(e.getFullYear()), o = t(e.getMonth()), i = t(e.getDate()), a = t(e.getHours()), u = t(e.getMinutes()), c = t(e.getSeconds());
    return `${r}-${o}-${i} ${a}:${u}:${c}`;
  }
  /**
   * Log a message at the level specified in first argument.
   *
   * @param level the log level
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static log(t, e, r, ...o) {
    if (Qe() && !(t === "DEBUG" && !Vo()))
      switch (t) {
        case "DEBUG":
          console.debug(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
        case "INFO":
          console.info(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
        case "WARN":
          console.warn(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
        case "ERROR":
          console.error(`${G.currentDate} - ${e}: ${r}`, ...o);
          break;
      }
  }
  /**
   * Log a message at the DEBUG level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static debug(t, e, ...r) {
    G.log("DEBUG", t, e, ...r);
  }
  /**
   * Log a message at the INFO level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static info(t, e, ...r) {
    G.log("INFO", t, e, ...r);
  }
  /**
   * Log a message at the WARN level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static warn(t, e, ...r) {
    G.log("WARN", t, e, ...r);
  }
  /**
   * Log a message at the ERROR level.
   *
   * @param name the name of the logger to distinguish individual loggers
   * @param message the log message
   * @param data an additional arguments to include in the log
   */
  static error(t, e, ...r) {
    G.log("ERROR", t, e, ...r);
  }
}
function Ki(n, t = "d. M. yyyy H:mm", e) {
  if (!n)
    return "";
  try {
    return Or(n, t, R({ locale: Qo }, e));
  } catch (r) {
    return Qe() && G.error("utilities", "Invalid date string received", n), n instanceof Date ? n.toString() : `${n}`;
  }
}
function bt(n, t) {
  var e, r;
  (r = (e = window.dtrum) == null ? void 0 : e.reportCustomError) == null || r.call(e, "REACT", n, t);
}
const zo = (n) => n.split(".").map((t, e) => e ? co(t) : t).join(""), Xo = (n, t, e) => n ? t ? "danger" : "success" : e;
function Ji(n, t = {}) {
  const e = new Event(n), r = new EventTarget();
  return tt(R({}, e), {
    target: R(R({}, r), t)
  });
}
var Uo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
(function(n) {
  n();
})(function() {
  function n(l, d) {
    if (!(l instanceof d))
      throw new TypeError("Cannot call a class as a function");
  }
  function t(l, d) {
    for (var m = 0; m < d.length; m++) {
      var g = d[m];
      g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(l, g.key, g);
    }
  }
  function e(l, d, m) {
    return d && t(l.prototype, d), m && t(l, m), Object.defineProperty(l, "prototype", {
      writable: !1
    }), l;
  }
  function r(l, d) {
    if (typeof d != "function" && d !== null)
      throw new TypeError("Super expression must either be null or a function");
    l.prototype = Object.create(d && d.prototype, {
      constructor: {
        value: l,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(l, "prototype", {
      writable: !1
    }), d && i(l, d);
  }
  function o(l) {
    return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(d) {
      return d.__proto__ || Object.getPrototypeOf(d);
    }, o(l);
  }
  function i(l, d) {
    return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(m, g) {
      return m.__proto__ = g, m;
    }, i(l, d);
  }
  function a() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (l) {
      return !1;
    }
  }
  function u(l) {
    if (l === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return l;
  }
  function c(l, d) {
    if (d && (typeof d == "object" || typeof d == "function"))
      return d;
    if (d !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return u(l);
  }
  function s(l) {
    var d = a();
    return function() {
      var m = o(l), g;
      if (d) {
        var v = o(this).constructor;
        g = Reflect.construct(m, arguments, v);
      } else
        g = m.apply(this, arguments);
      return c(this, g);
    };
  }
  function f(l, d) {
    for (; !Object.prototype.hasOwnProperty.call(l, d) && (l = o(l), l !== null); )
      ;
    return l;
  }
  function p() {
    return typeof Reflect != "undefined" && Reflect.get ? p = Reflect.get.bind() : p = function(l, d, m) {
      var g = f(l, d);
      if (g) {
        var v = Object.getOwnPropertyDescriptor(g, d);
        return v.get ? v.get.call(arguments.length < 3 ? l : m) : v.value;
      }
    }, p.apply(this, arguments);
  }
  var b = /* @__PURE__ */ function() {
    function l() {
      n(this, l), Object.defineProperty(this, "listeners", {
        value: {},
        writable: !0,
        configurable: !0
      });
    }
    return e(l, [{
      key: "addEventListener",
      value: function(d, m, g) {
        d in this.listeners || (this.listeners[d] = []), this.listeners[d].push({
          callback: m,
          options: g
        });
      }
    }, {
      key: "removeEventListener",
      value: function(d, m) {
        if (d in this.listeners) {
          for (var g = this.listeners[d], v = 0, H = g.length; v < H; v++)
            if (g[v].callback === m) {
              g.splice(v, 1);
              return;
            }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function(d) {
        if (d.type in this.listeners) {
          for (var m = this.listeners[d.type], g = m.slice(), v = 0, H = g.length; v < H; v++) {
            var I = g[v];
            try {
              I.callback.call(this, d);
            } catch (C) {
              Promise.resolve().then(function() {
                throw C;
              });
            }
            I.options && I.options.once && this.removeEventListener(d.type, I.callback);
          }
          return !d.defaultPrevented;
        }
      }
    }]), l;
  }(), y = /* @__PURE__ */ function(l) {
    r(m, l);
    var d = s(m);
    function m() {
      var g;
      return n(this, m), g = d.call(this), g.listeners || b.call(u(g)), Object.defineProperty(u(g), "aborted", {
        value: !1,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(u(g), "onabort", {
        value: null,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(u(g), "reason", {
        value: void 0,
        writable: !0,
        configurable: !0
      }), g;
    }
    return e(m, [{
      key: "toString",
      value: function() {
        return "[object AbortSignal]";
      }
    }, {
      key: "dispatchEvent",
      value: function(g) {
        g.type === "abort" && (this.aborted = !0, typeof this.onabort == "function" && this.onabort.call(this, g)), p(o(m.prototype), "dispatchEvent", this).call(this, g);
      }
    }]), m;
  }(b), w = /* @__PURE__ */ function() {
    function l() {
      n(this, l), Object.defineProperty(this, "signal", {
        value: new y(),
        writable: !0,
        configurable: !0
      });
    }
    return e(l, [{
      key: "abort",
      value: function(d) {
        var m;
        try {
          m = new Event("abort");
        } catch (v) {
          typeof document != "undefined" ? document.createEvent ? (m = document.createEvent("Event"), m.initEvent("abort", !1, !1)) : (m = document.createEventObject(), m.type = "abort") : m = {
            type: "abort",
            bubbles: !1,
            cancelable: !1
          };
        }
        var g = d;
        if (g === void 0)
          if (typeof document == "undefined")
            g = new Error("This operation was aborted"), g.name = "AbortError";
          else
            try {
              g = new DOMException("signal is aborted without reason");
            } catch (v) {
              g = new Error("This operation was aborted"), g.name = "AbortError";
            }
        this.signal.reason = g, this.signal.dispatchEvent(m);
      }
    }, {
      key: "toString",
      value: function() {
        return "[object AbortController]";
      }
    }]), l;
  }();
  typeof Symbol != "undefined" && Symbol.toStringTag && (w.prototype[Symbol.toStringTag] = "AbortController", y.prototype[Symbol.toStringTag] = "AbortSignal");
  function P(l) {
    return l.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : typeof l.Request == "function" && !l.Request.prototype.hasOwnProperty("signal") || !l.AbortController;
  }
  function S(l) {
    typeof l == "function" && (l = {
      fetch: l
    });
    var d = l, m = d.fetch, g = d.Request, v = g === void 0 ? m.Request : g, H = d.AbortController, I = d.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL, C = I === void 0 ? !1 : I;
    if (!P({
      fetch: m,
      Request: v,
      AbortController: H,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: C
    }))
      return {
        fetch: m,
        Request: A
      };
    var A = v;
    (A && !A.prototype.hasOwnProperty("signal") || C) && (A = function(M, O) {
      var W;
      O && O.signal && (W = O.signal, delete O.signal);
      var $ = new v(M, O);
      return W && Object.defineProperty($, "signal", {
        writable: !1,
        enumerable: !1,
        configurable: !0,
        value: W
      }), $;
    }, A.prototype = v.prototype);
    var N = m, B = function(M, O) {
      var W = A && A.prototype.isPrototypeOf(M) ? M.signal : O ? O.signal : void 0;
      if (W) {
        var $;
        try {
          $ = new DOMException("Aborted", "AbortError");
        } catch (Lt) {
          $ = new Error("Aborted"), $.name = "AbortError";
        }
        if (W.aborted)
          return Promise.reject($);
        var Dt = new Promise(function(Lt, Nt) {
          W.addEventListener("abort", function() {
            return Nt($);
          }, {
            once: !0
          });
        });
        return O && O.signal && delete O.signal, Promise.race([Dt, N(M, O)]);
      }
      return N(M, O);
    };
    return {
      fetch: B,
      Request: A
    };
  }
  (function(l) {
    if (P(l)) {
      if (!l.fetch) {
        console.warn("fetch() is not available, cannot install abortcontroller-polyfill");
        return;
      }
      var d = S(l), m = d.fetch, g = d.Request;
      l.fetch = m, l.Request = g, Object.defineProperty(l, "AbortController", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: w
      }), Object.defineProperty(l, "AbortSignal", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: y
      });
    }
  })(typeof self != "undefined" ? self : Uo);
});
class Ko extends Error {
  constructor(t, e) {
    super(e), h(this, "_body"), Object.setPrototypeOf(this, new.target.prototype), this._body = t;
  }
  get body() {
    return this._body;
  }
}
class Jo extends Error {
  constructor(t, e) {
    super(e), h(this, "_errors"), Object.setPrototypeOf(this, new.target.prototype), this._errors = t.errors;
  }
  get errors() {
    return this._errors;
  }
}
class Zo extends Error {
  constructor(t, e) {
    super(e), h(this, "_body"), Object.setPrototypeOf(this, new.target.prototype), this._body = t;
  }
  get body() {
    return this._body;
  }
}
const ti = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest"
}, ei = 15e3;
function ni(n, t, e) {
  return nt(this, null, function* () {
    let r;
    const o = setTimeout(() => {
      r = !0, e.abort();
    }, t.timeout);
    try {
      const i = yield n;
      return clearTimeout(o), i;
    } catch (i) {
      if ((i == null ? void 0 : i.name) === "AbortError" && r) {
        const a = { status: 408, statusText: "TIMEOUT" }, u = JSON.stringify({ code: 408, message: "TIMEOUT" });
        return r = void 0, console.error(`${t.method} ${t.url} 408 (Request Timeout)`), new Response(u, a);
      }
      if ((i == null ? void 0 : i.name) === "AbortError" && !r) {
        const a = { status: 500, statusText: "ABORTED" }, u = JSON.stringify({ code: 500, message: "ABORTED" });
        return console.error(`${t.method} ${t.url} AbortError: The operation was aborted.`), new Response(u, a);
      }
      throw console.error(i), i;
    }
  });
}
function ri(n, t = "json") {
  return nt(this, null, function* () {
    if (n.status === 200) {
      let r;
      switch (t) {
        case "arrayBuffer":
          r = yield n.arrayBuffer();
          break;
        case "blob":
          r = yield n.blob();
          break;
        case "text":
          r = yield n.text();
          break;
        case "json":
          r = yield n.json();
      }
      return r;
    }
    const e = {
      url: n.url,
      headers: n.headers,
      status: n.status,
      statusText: n.statusText,
      type: t
    };
    if (n.status === 400 || n.status === 405 || n.status === 412) {
      const r = yield n.json(), o = new Ko(r);
      throw bt(
        "Request failed",
        JSON.stringify(tt(R({}, e), {
          body: o.body
        }))
      ), o.body;
    }
    if (n.status === 403) {
      const r = yield n.json(), o = new Zo(r);
      throw bt(
        "Request failed - Forbidden",
        JSON.stringify(tt(R({}, e), {
          body: o.body
        }))
      ), R({
        status: 403
      }, o.body);
    }
    if (n.status === 422) {
      const r = yield n.json(), o = new Jo(r);
      throw bt(
        "Request failed",
        JSON.stringify(tt(R({}, e), {
          body: { code: o.errors }
        }))
      ), { code: JSON.stringify(o.errors) };
    }
    if (n.status === 401) {
      const r = yield n.json();
      throw bt(
        "Request failed",
        JSON.stringify(tt(R({}, e), {
          body: R({}, r)
        }))
      ), R({
        status: 401
      }, r);
    }
    throw bt(
      "Request failed",
      JSON.stringify(tt(R({}, e), {
        body: { code: n.statusText }
      }))
    ), { code: n.statusText };
  });
}
function oi(n, t, e) {
  const r = { method: n, headers: R(R({}, ti), t) }, o = ["GET", "DELETE"].indexOf(n) === -1 ? { body: JSON.stringify(e) } : {};
  return R(R({}, r), o);
}
function ii(n = "json") {
  switch (n) {
    case "arrayBuffer":
      return "application/octet-stream";
    case "blob":
      return "application/octet-stream";
    case "text":
      return "text/plain";
    default:
      return "application/json";
  }
}
function Pt(n, t) {
  return nt(this, arguments, function* (e, r, o = {}, i, a) {
    const u = new AbortController(), { signal: c } = u, s = o, { timeout: f, type: p } = s, b = bn(s, ["timeout", "type"]), y = oi(r, R({ Accept: ii(p) }, b), i);
    a == null || a(u);
    const w = yield ni(
      fetch(e, tt(R({}, y), { signal: c })),
      { url: e, method: r, timeout: f || ei },
      u
    );
    return ri(w, p);
  });
}
function ai(n, t, e) {
  return nt(this, null, function* () {
    return Pt(n, "GET", t, void 0, e);
  });
}
function si(n, t, e, r) {
  return nt(this, null, function* () {
    return Pt(n, "POST", e, t, r);
  });
}
function ui(n, t, e, r) {
  return nt(this, null, function* () {
    return Pt(n, "PUT", e, t, r);
  });
}
function ci(n, t, e) {
  return nt(this, null, function* () {
    return Pt(n, "DELETE", t, void 0, e);
  });
}
function li(n, t, e, r) {
  return nt(this, null, function* () {
    return Pt(n, "PATCH", e, t, r);
  });
}
const Zi = { get: ai, post: si, put: ui, delete: ci, patch: li };
function ta(n, t) {
  let e = n;
  for (const r in t) {
    const o = r.replace(/^:|%3A/, ""), i = String(t[r]);
    e.includes(`%3A${o}`) ? e = e.replace(`%3A${o}`, encodeURIComponent(i)) : e = e.replace(`:${o}`, encodeURIComponent(i));
  }
  return e;
}
function Y(n) {
  for (var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    e[r - 1] = arguments[r];
  throw Error("[Immer] minified error nr: " + n + (e.length ? " " + e.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function it(n) {
  return !!n && !!n[E];
}
function at(n) {
  var t;
  return !!n && (function(e) {
    if (!e || typeof e != "object")
      return !1;
    var r = Object.getPrototypeOf(e);
    if (r === null)
      return !0;
    var o = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return o === Object || typeof o == "function" && Function.toString.call(o) === wi;
  }(n) || Array.isArray(n) || !!n[ke] || !!(!((t = n.constructor) === null || t === void 0) && t[ke]) || te(n) || ee(n));
}
function st(n, t, e) {
  e === void 0 && (e = !1), mt(n) === 0 ? (e ? Object.keys : dt)(n).forEach(function(r) {
    e && typeof r == "symbol" || t(r, n[r], n);
  }) : n.forEach(function(r, o) {
    return t(o, r, n);
  });
}
function mt(n) {
  var t = n[E];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : te(n) ? 2 : ee(n) ? 3 : 0;
}
function lt(n, t) {
  return mt(n) === 2 ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function di(n, t) {
  return mt(n) === 2 ? n.get(t) : n[t];
}
function Ve(n, t, e) {
  var r = mt(n);
  r === 2 ? n.set(t, e) : r === 3 ? n.add(e) : n[t] = e;
}
function ze(n, t) {
  return n === t ? n !== 0 || 1 / n == 1 / t : n != n && t != t;
}
function te(n) {
  return bi && n instanceof Map;
}
function ee(n) {
  return yi && n instanceof Set;
}
function ot(n) {
  return n.o || n.t;
}
function ne(n) {
  if (Array.isArray(n))
    return Array.prototype.slice.call(n);
  var t = Ue(n);
  delete t[E];
  for (var e = dt(t), r = 0; r < e.length; r++) {
    var o = e[r], i = t[o];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: n[o] });
  }
  return Object.create(Object.getPrototypeOf(n), t);
}
function re(n, t) {
  return t === void 0 && (t = !1), oe(n) || it(n) || !at(n) || (mt(n) > 1 && (n.set = n.add = n.clear = n.delete = fi), Object.freeze(n), t && st(n, function(e, r) {
    return re(r, !0);
  }, !0)), n;
}
function fi() {
  Y(2);
}
function oe(n) {
  return n == null || typeof n != "object" || Object.isFrozen(n);
}
function U(n) {
  var t = Vt[n];
  return t || Y(18, n), t;
}
function hi(n, t) {
  Vt[n] || (Vt[n] = t);
}
function $t() {
  return vt;
}
function Ht(n, t) {
  t && (U("Patches"), n.u = [], n.s = [], n.v = t);
}
function Et(n) {
  Gt(n), n.p.forEach(pi), n.p = null;
}
function Gt(n) {
  n === vt && (vt = n.l);
}
function ye(n) {
  return vt = { p: [], l: vt, h: n, m: !0, _: 0 };
}
function pi(n) {
  var t = n[E];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function _t(n, t) {
  t._ = t.p.length;
  var e = t.p[0], r = n !== void 0 && n !== e;
  return t.h.O || U("ES5").S(t, n, r), r ? (e[E].P && (Et(t), Y(4)), at(n) && (n = Tt(t, n), t.l || Mt(t, n)), t.u && U("Patches").M(e[E].t, n, t.u, t.s)) : n = Tt(t, e, []), Et(t), t.u && t.v(t.u, t.s), n !== Xe ? n : void 0;
}
function Tt(n, t, e) {
  if (oe(t))
    return t;
  var r = t[E];
  if (!r)
    return st(t, function(u, c) {
      return we(n, r, t, u, c, e);
    }, !0), t;
  if (r.A !== n)
    return t;
  if (!r.P)
    return Mt(n, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var o = r.i === 4 || r.i === 5 ? r.o = ne(r.k) : r.o, i = o, a = !1;
    r.i === 3 && (i = new Set(o), o.clear(), a = !0), st(i, function(u, c) {
      return we(n, r, o, u, c, e, a);
    }), Mt(n, o, !1), e && n.u && U("Patches").N(r, e, n.u, n.s);
  }
  return r.o;
}
function we(n, t, e, r, o, i, a) {
  if (it(o)) {
    var u = Tt(n, o, i && t && t.i !== 3 && !lt(t.R, r) ? i.concat(r) : void 0);
    if (Ve(e, r, u), !it(u))
      return;
    n.m = !1;
  } else
    a && e.add(o);
  if (at(o) && !oe(o)) {
    if (!n.h.D && n._ < 1)
      return;
    Tt(n, o), t && t.A.l || Mt(n, o);
  }
}
function Mt(n, t, e) {
  e === void 0 && (e = !1), !n.l && n.h.D && n.m && re(t, e);
}
function Wt(n, t) {
  var e = n[E];
  return (e ? ot(e) : n)[t];
}
function ve(n, t) {
  if (t in n)
    for (var e = Object.getPrototypeOf(n); e; ) {
      var r = Object.getOwnPropertyDescriptor(e, t);
      if (r)
        return r;
      e = Object.getPrototypeOf(e);
    }
}
function et(n) {
  n.P || (n.P = !0, n.l && et(n.l));
}
function Ft(n) {
  n.o || (n.o = ne(n.t));
}
function Qt(n, t, e) {
  var r = te(t) ? U("MapSet").F(t, e) : ee(t) ? U("MapSet").T(t, e) : n.O ? function(o, i) {
    var a = Array.isArray(o), u = { i: a ? 1 : 0, A: i ? i.A : $t(), P: !1, I: !1, R: {}, l: i, t: o, k: null, o: null, j: null, C: !1 }, c = u, s = xt;
    a && (c = [u], s = yt);
    var f = Proxy.revocable(c, s), p = f.revoke, b = f.proxy;
    return u.k = b, u.j = p, b;
  }(t, e) : U("ES5").J(t, e);
  return (e ? e.A : $t()).p.push(r), r;
}
function mi(n) {
  return it(n) || Y(22, n), function t(e) {
    if (!at(e))
      return e;
    var r, o = e[E], i = mt(e);
    if (o) {
      if (!o.P && (o.i < 4 || !U("ES5").K(o)))
        return o.t;
      o.I = !0, r = xe(e, i), o.I = !1;
    } else
      r = xe(e, i);
    return st(r, function(a, u) {
      o && di(o.t, a) === u || Ve(r, a, t(u));
    }), i === 3 ? new Set(r) : r;
  }(n);
}
function xe(n, t) {
  switch (t) {
    case 2:
      return new Map(n);
    case 3:
      return Array.from(n);
  }
  return ne(n);
}
function gi() {
  function n(i, a) {
    var u = o[i];
    return u ? u.enumerable = a : o[i] = u = { configurable: !0, enumerable: a, get: function() {
      var c = this[E];
      return xt.get(c, i);
    }, set: function(c) {
      var s = this[E];
      xt.set(s, i, c);
    } }, u;
  }
  function t(i) {
    for (var a = i.length - 1; a >= 0; a--) {
      var u = i[a][E];
      if (!u.P)
        switch (u.i) {
          case 5:
            r(u) && et(u);
            break;
          case 4:
            e(u) && et(u);
        }
    }
  }
  function e(i) {
    for (var a = i.t, u = i.k, c = dt(u), s = c.length - 1; s >= 0; s--) {
      var f = c[s];
      if (f !== E) {
        var p = a[f];
        if (p === void 0 && !lt(a, f))
          return !0;
        var b = u[f], y = b && b[E];
        if (y ? y.t !== p : !ze(b, p))
          return !0;
      }
    }
    var w = !!a[E];
    return c.length !== dt(a).length + (w ? 0 : 1);
  }
  function r(i) {
    var a = i.k;
    if (a.length !== i.t.length)
      return !0;
    var u = Object.getOwnPropertyDescriptor(a, a.length - 1);
    if (u && !u.get)
      return !0;
    for (var c = 0; c < a.length; c++)
      if (!a.hasOwnProperty(c))
        return !0;
    return !1;
  }
  var o = {};
  hi("ES5", { J: function(i, a) {
    var u = Array.isArray(i), c = function(f, p) {
      if (f) {
        for (var b = Array(p.length), y = 0; y < p.length; y++)
          Object.defineProperty(b, "" + y, n(y, !0));
        return b;
      }
      var w = Ue(p);
      delete w[E];
      for (var P = dt(w), S = 0; S < P.length; S++) {
        var l = P[S];
        w[l] = n(l, f || !!w[l].enumerable);
      }
      return Object.create(Object.getPrototypeOf(p), w);
    }(u, i), s = { i: u ? 5 : 4, A: a ? a.A : $t(), P: !1, I: !1, R: {}, l: a, t: i, k: c, o: null, g: !1, C: !1 };
    return Object.defineProperty(c, E, { value: s, writable: !0 }), c;
  }, S: function(i, a, u) {
    u ? it(a) && a[E].A === i && t(i.p) : (i.u && function c(s) {
      if (s && typeof s == "object") {
        var f = s[E];
        if (f) {
          var p = f.t, b = f.k, y = f.R, w = f.i;
          if (w === 4)
            st(b, function(m) {
              m !== E && (p[m] !== void 0 || lt(p, m) ? y[m] || c(b[m]) : (y[m] = !0, et(f)));
            }), st(p, function(m) {
              b[m] !== void 0 || lt(b, m) || (y[m] = !1, et(f));
            });
          else if (w === 5) {
            if (r(f) && (et(f), y.length = !0), b.length < p.length)
              for (var P = b.length; P < p.length; P++)
                y[P] = !1;
            else
              for (var S = p.length; S < b.length; S++)
                y[S] = !0;
            for (var l = Math.min(b.length, p.length), d = 0; d < l; d++)
              b.hasOwnProperty(d) || (y[d] = !0), y[d] === void 0 && c(b[d]);
          }
        }
      }
    }(i.p[0]), t(i.p));
  }, K: function(i) {
    return i.i === 4 ? e(i) : r(i);
  } });
}
var Oe, vt, ie = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", bi = typeof Map != "undefined", yi = typeof Set != "undefined", Pe = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", Xe = ie ? Symbol.for("immer-nothing") : ((Oe = {})["immer-nothing"] = !0, Oe), ke = ie ? Symbol.for("immer-draftable") : "__$immer_draftable", E = ie ? Symbol.for("immer-state") : "__$immer_state", wi = "" + Object.prototype.constructor, dt = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(n) {
  return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, Ue = Object.getOwnPropertyDescriptors || function(n) {
  var t = {};
  return dt(n).forEach(function(e) {
    t[e] = Object.getOwnPropertyDescriptor(n, e);
  }), t;
}, Vt = {}, xt = { get: function(n, t) {
  if (t === E)
    return n;
  var e = ot(n);
  if (!lt(e, t))
    return function(o, i, a) {
      var u, c = ve(i, a);
      return c ? "value" in c ? c.value : (u = c.get) === null || u === void 0 ? void 0 : u.call(o.k) : void 0;
    }(n, e, t);
  var r = e[t];
  return n.I || !at(r) ? r : r === Wt(n.t, t) ? (Ft(n), n.o[t] = Qt(n.A.h, r, n)) : r;
}, has: function(n, t) {
  return t in ot(n);
}, ownKeys: function(n) {
  return Reflect.ownKeys(ot(n));
}, set: function(n, t, e) {
  var r = ve(ot(n), t);
  if (r != null && r.set)
    return r.set.call(n.k, e), !0;
  if (!n.P) {
    var o = Wt(ot(n), t), i = o == null ? void 0 : o[E];
    if (i && i.t === e)
      return n.o[t] = e, n.R[t] = !1, !0;
    if (ze(e, o) && (e !== void 0 || lt(n.t, t)))
      return !0;
    Ft(n), et(n);
  }
  return n.o[t] === e && (e !== void 0 || t in n.o) || Number.isNaN(e) && Number.isNaN(n.o[t]) || (n.o[t] = e, n.R[t] = !0), !0;
}, deleteProperty: function(n, t) {
  return Wt(n.t, t) !== void 0 || t in n.t ? (n.R[t] = !1, Ft(n), et(n)) : delete n.R[t], n.o && delete n.o[t], !0;
}, getOwnPropertyDescriptor: function(n, t) {
  var e = ot(n), r = Reflect.getOwnPropertyDescriptor(e, t);
  return r && { writable: !0, configurable: n.i !== 1 || t !== "length", enumerable: r.enumerable, value: e[t] };
}, defineProperty: function() {
  Y(11);
}, getPrototypeOf: function(n) {
  return Object.getPrototypeOf(n.t);
}, setPrototypeOf: function() {
  Y(12);
} }, yt = {};
st(xt, function(n, t) {
  yt[n] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), yt.deleteProperty = function(n, t) {
  return yt.set.call(this, n, t, void 0);
}, yt.set = function(n, t, e) {
  return xt.set.call(this, n[0], t, e, n[0]);
};
var vi = function() {
  function n(e) {
    var r = this;
    this.O = Pe, this.D = !0, this.produce = function(o, i, a) {
      if (typeof o == "function" && typeof i != "function") {
        var u = i;
        i = o;
        var c = r;
        return function(P) {
          var S = this;
          P === void 0 && (P = u);
          for (var l = arguments.length, d = Array(l > 1 ? l - 1 : 0), m = 1; m < l; m++)
            d[m - 1] = arguments[m];
          return c.produce(P, function(g) {
            var v;
            return (v = i).call.apply(v, [S, g].concat(d));
          });
        };
      }
      var s;
      if (typeof i != "function" && Y(6), a !== void 0 && typeof a != "function" && Y(7), at(o)) {
        var f = ye(r), p = Qt(r, o, void 0), b = !0;
        try {
          s = i(p), b = !1;
        } finally {
          b ? Et(f) : Gt(f);
        }
        return typeof Promise != "undefined" && s instanceof Promise ? s.then(function(P) {
          return Ht(f, a), _t(P, f);
        }, function(P) {
          throw Et(f), P;
        }) : (Ht(f, a), _t(s, f));
      }
      if (!o || typeof o != "object") {
        if ((s = i(o)) === void 0 && (s = o), s === Xe && (s = void 0), r.D && re(s, !0), a) {
          var y = [], w = [];
          U("Patches").M(o, s, y, w), a(y, w);
        }
        return s;
      }
      Y(21, o);
    }, this.produceWithPatches = function(o, i) {
      if (typeof o == "function")
        return function(s) {
          for (var f = arguments.length, p = Array(f > 1 ? f - 1 : 0), b = 1; b < f; b++)
            p[b - 1] = arguments[b];
          return r.produceWithPatches(s, function(y) {
            return o.apply(void 0, [y].concat(p));
          });
        };
      var a, u, c = r.produce(o, i, function(s, f) {
        a = s, u = f;
      });
      return typeof Promise != "undefined" && c instanceof Promise ? c.then(function(s) {
        return [s, a, u];
      }) : [c, a, u];
    }, typeof (e == null ? void 0 : e.useProxies) == "boolean" && this.setUseProxies(e.useProxies), typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze);
  }
  var t = n.prototype;
  return t.createDraft = function(e) {
    at(e) || Y(8), it(e) && (e = mi(e));
    var r = ye(this), o = Qt(this, e, void 0);
    return o[E].C = !0, Gt(r), o;
  }, t.finishDraft = function(e, r) {
    var o = e && e[E], i = o.A;
    return Ht(i, r), _t(void 0, i);
  }, t.setAutoFreeze = function(e) {
    this.D = e;
  }, t.setUseProxies = function(e) {
    e && !Pe && Y(20), this.O = e;
  }, t.applyPatches = function(e, r) {
    var o;
    for (o = r.length - 1; o >= 0; o--) {
      var i = r[o];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    o > -1 && (r = r.slice(o + 1));
    var a = U("Patches").$;
    return it(e) ? a(e, r) : this.produce(e, function(u) {
      return a(u, r);
    });
  }, n;
}(), F = new vi();
F.produce;
F.produceWithPatches.bind(F);
F.setAutoFreeze.bind(F);
F.setUseProxies.bind(F);
F.applyPatches.bind(F);
F.createDraft.bind(F);
F.finishDraft.bind(F);
var Ke = globalThis && globalThis.__extends || function() {
  var n = function(t, e) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, n(t, e);
  };
  return function(t, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    n(t, e);
    function r() {
      this.constructor = t;
    }
    t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
  };
}(), xi = globalThis && globalThis.__generator || function(n, t) {
  var e = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(f) {
      return c([s, f]);
    };
  }
  function c(s) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (r = 1, o && (i = s[0] & 2 ? o.return : s[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, s[1])).done)
          return i;
        switch (o = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return e.label++, { value: s[1], done: !1 };
          case 5:
            e.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (i = e.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              e = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              e.label = s[1];
              break;
            }
            if (s[0] === 6 && e.label < i[1]) {
              e.label = i[1], i = s;
              break;
            }
            if (i && e.label < i[2]) {
              e.label = i[2], e.ops.push(s);
              break;
            }
            i[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        s = t.call(n, e);
      } catch (f) {
        s = [6, f], o = 0;
      } finally {
        r = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, jt = globalThis && globalThis.__spreadArray || function(n, t) {
  for (var e = 0, r = t.length, o = n.length; e < r; e++, o++)
    n[o] = t[e];
  return n;
}, Oi = Object.defineProperty, Pi = Object.defineProperties, ki = Object.getOwnPropertyDescriptors, Se = Object.getOwnPropertySymbols, Si = Object.prototype.hasOwnProperty, Ei = Object.prototype.propertyIsEnumerable, Ee = function(n, t, e) {
  return t in n ? Oi(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
}, wt = function(n, t) {
  for (var e in t || (t = {}))
    Si.call(t, e) && Ee(n, e, t[e]);
  if (Se)
    for (var r = 0, o = Se(t); r < o.length; r++) {
      var e = o[r];
      Ei.call(t, e) && Ee(n, e, t[e]);
    }
  return n;
}, Ct = function(n, t) {
  return Pi(n, ki(t));
}, Ti = function(n, t, e) {
  return new Promise(function(r, o) {
    var i = function(c) {
      try {
        u(e.next(c));
      } catch (s) {
        o(s);
      }
    }, a = function(c) {
      try {
        u(e.throw(c));
      } catch (s) {
        o(s);
      }
    }, u = function(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(i, a);
    };
    u((e = e.apply(n, t)).next());
  });
};
function ft(n, t) {
  function e() {
    for (var r = [], o = 0; o < arguments.length; o++)
      r[o] = arguments[o];
    if (t) {
      var i = t.apply(void 0, r);
      if (!i)
        throw new Error("prepareAction did not return an object");
      return wt(wt({
        type: n,
        payload: i.payload
      }, "meta" in i && { meta: i.meta }), "error" in i && { error: i.error });
    }
    return { type: n, payload: r[0] };
  }
  return e.toString = function() {
    return "" + n;
  }, e.type = n, e.match = function(r) {
    return r.type === n;
  }, e;
}
(function(n) {
  Ke(t, n);
  function t() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    var o = n.apply(this, e) || this;
    return Object.setPrototypeOf(o, t.prototype), o;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return n.prototype.concat.apply(this, e);
  }, t.prototype.prepend = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.length === 1 && Array.isArray(e[0]) ? new (t.bind.apply(t, jt([void 0], e[0].concat(this))))() : new (t.bind.apply(t, jt([void 0], e.concat(this))))();
  }, t;
})(Array);
(function(n) {
  Ke(t, n);
  function t() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    var o = n.apply(this, e) || this;
    return Object.setPrototypeOf(o, t.prototype), o;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return n.prototype.concat.apply(this, e);
  }, t.prototype.prepend = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.length === 1 && Array.isArray(e[0]) ? new (t.bind.apply(t, jt([void 0], e[0].concat(this))))() : new (t.bind.apply(t, jt([void 0], e.concat(this))))();
  }, t;
})(Array);
var Mi = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", ji = function(n) {
  n === void 0 && (n = 21);
  for (var t = "", e = n; e--; )
    t += Mi[Math.random() * 64 | 0];
  return t;
}, Ai = [
  "name",
  "message",
  "stack",
  "code"
], Bt = (
  /** @class */
  function() {
    function n(t, e) {
      this.payload = t, this.meta = e;
    }
    return n;
  }()
), Te = (
  /** @class */
  function() {
    function n(t, e) {
      this.payload = t, this.meta = e;
    }
    return n;
  }()
), Di = function(n) {
  if (typeof n == "object" && n !== null) {
    for (var t = {}, e = 0, r = Ai; e < r.length; e++) {
      var o = r[e];
      typeof n[o] == "string" && (t[o] = n[o]);
    }
    return t;
  }
  return { message: String(n) };
};
(function() {
  function n(t, e, r) {
    var o = ft(t + "/fulfilled", function(s, f, p, b) {
      return {
        payload: s,
        meta: Ct(wt({}, b || {}), {
          arg: p,
          requestId: f,
          requestStatus: "fulfilled"
        })
      };
    }), i = ft(t + "/pending", function(s, f, p) {
      return {
        payload: void 0,
        meta: Ct(wt({}, p || {}), {
          arg: f,
          requestId: s,
          requestStatus: "pending"
        })
      };
    }), a = ft(t + "/rejected", function(s, f, p, b, y) {
      return {
        payload: b,
        error: (r && r.serializeError || Di)(s || "Rejected"),
        meta: Ct(wt({}, y || {}), {
          arg: p,
          requestId: f,
          rejectedWithValue: !!b,
          requestStatus: "rejected",
          aborted: (s == null ? void 0 : s.name) === "AbortError",
          condition: (s == null ? void 0 : s.name) === "ConditionError"
        })
      };
    }), u = typeof AbortController != "undefined" ? AbortController : (
      /** @class */
      function() {
        function s() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return s.prototype.abort = function() {
        }, s;
      }()
    );
    function c(s) {
      return function(f, p, b) {
        var y = r != null && r.idGenerator ? r.idGenerator(s) : ji(), w = new u(), P;
        function S(d) {
          P = d, w.abort();
        }
        var l = function() {
          return Ti(this, null, function() {
            var d, m, g, v, H, I, C;
            return xi(this, function(A) {
              switch (A.label) {
                case 0:
                  return A.trys.push([0, 4, , 5]), v = (d = r == null ? void 0 : r.condition) == null ? void 0 : d.call(r, s, { getState: p, extra: b }), Ni(v) ? [4, v] : [3, 2];
                case 1:
                  v = A.sent(), A.label = 2;
                case 2:
                  if (v === !1 || w.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return H = new Promise(function(N, B) {
                    return w.signal.addEventListener("abort", function() {
                      return B({
                        name: "AbortError",
                        message: P || "Aborted"
                      });
                    });
                  }), f(i(y, s, (m = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : m.call(r, { requestId: y, arg: s }, { getState: p, extra: b }))), [4, Promise.race([
                    H,
                    Promise.resolve(e(s, {
                      dispatch: f,
                      getState: p,
                      extra: b,
                      requestId: y,
                      signal: w.signal,
                      abort: S,
                      rejectWithValue: function(N, B) {
                        return new Bt(N, B);
                      },
                      fulfillWithValue: function(N, B) {
                        return new Te(N, B);
                      }
                    })).then(function(N) {
                      if (N instanceof Bt)
                        throw N;
                      return N instanceof Te ? o(N.payload, y, s, N.meta) : o(N, y, s);
                    })
                  ])];
                case 3:
                  return g = A.sent(), [3, 5];
                case 4:
                  return I = A.sent(), g = I instanceof Bt ? a(null, y, s, I.payload, I.meta) : a(I, y, s), [3, 5];
                case 5:
                  return C = r && !r.dispatchConditionRejection && a.match(g) && g.meta.condition, C || f(g), [2, g];
              }
            });
          });
        }();
        return Object.assign(l, {
          abort: S,
          requestId: y,
          arg: s,
          unwrap: function() {
            return l.then(Li);
          }
        });
      };
    }
    return Object.assign(c, {
      pending: i,
      rejected: a,
      fulfilled: o,
      typePrefix: t
    });
  }
  return n.withTypes = function() {
    return n;
  }, n;
})();
function Li(n) {
  if (n.meta && n.meta.rejectedWithValue)
    throw n.payload;
  if (n.error)
    throw n.error;
  return n.payload;
}
function Ni(n) {
  return n !== null && typeof n == "object" && typeof n.then == "function";
}
var ae = "listenerMiddleware";
ft(ae + "/add");
ft(ae + "/removeAll");
ft(ae + "/remove");
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window != "undefined" ? window : typeof global != "undefined" ? global : globalThis);
gi();
function Ri(n) {
  return Object.keys(n).reduce((t, e) => (n[e] !== void 0 && (t[e] = n[e]), t), {});
}
function ea(n) {
  const se = n, {
    m: t,
    mx: e,
    my: r,
    mt: o,
    mb: i,
    ms: a,
    me: u,
    p: c,
    px: s,
    py: f,
    pt: p,
    pb: b,
    ps: y,
    pe: w,
    bg: P,
    c: S,
    o: l,
    fs: d,
    ta: m,
    td: g,
    tt: v,
    w: H,
    h: I,
    d: C,
    b: A,
    bt: N,
    bb: B,
    bs: M,
    be: O,
    bc: W,
    rounded: $,
    alignSelf: Dt,
    flexFill: Lt,
    flexGrow: Nt,
    flexShrink: Ze,
    flexOrder: tn
  } = se, en = ce(se, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ms",
    "me",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "ps",
    "pe",
    "bg",
    "c",
    "o",
    "fs",
    "ta",
    "td",
    "tt",
    "w",
    "h",
    "d",
    "b",
    "bt",
    "bb",
    "bs",
    "be",
    "bc",
    "rounded",
    "alignSelf",
    "flexFill",
    "flexGrow",
    "flexShrink",
    "flexOrder"
  ]);
  return { styleProps: Ri({
    m: t,
    mx: e,
    my: r,
    mt: o,
    mb: i,
    ms: a,
    me: u,
    p: c,
    px: s,
    py: f,
    pt: p,
    pb: b,
    ps: y,
    pe: w,
    bg: P,
    c: S,
    o: l,
    fs: d,
    ta: m,
    td: g,
    tt: v,
    w: H,
    h: I,
    d: C,
    b: A,
    bt: N,
    bb: B,
    bs: M,
    be: O,
    bc: W,
    rounded: $,
    alignSelf: Dt,
    flexFill: Lt,
    flexGrow: Nt,
    flexShrink: Ze,
    flexOrder: tn
  }), other: en };
}
const Me = {
  c: "text",
  o: "opacity",
  ta: "text",
  td: "text-decoration",
  tt: "text",
  b: "border",
  bt: "border-top",
  bb: "border-bottom",
  bs: "border-start",
  be: "border-end",
  bc: "border",
  alignSelf: "align-self",
  flexFill: "flex",
  flexGrow: "flex",
  flexShrink: "flex",
  flexOrder: "order"
}, qi = {
  body1: "text-body-1",
  "body1-strong": "text-body-1-strong",
  body2: "text-body-2",
  "body2-strong": "text-body-2-strong",
  notes: "text-notes",
  "notes-strong": "text-notes-strong"
};
function Ii(n) {
  return n in Me ? Me[n] : n;
}
function Hi(n, t) {
  var e;
  if (n === "fs")
    return (e = qi[t]) != null ? e : `${t}`;
}
function _i(n, t) {
  if (["flexFill", "flexGrow", "flexShrink"].includes(n)) {
    const e = n.toLowerCase().replace("flex", "");
    return t === !0 ? e : `${e}-${t}`;
  }
  return t;
}
function na(n) {
  return Wi(
    n,
    Ii,
    Hi,
    _i
  );
}
function Wi(n, t, e, r) {
  return Object.entries(n).flatMap(([o, i]) => {
    if (i === !1)
      return i;
    const a = r ? r(o, i) : i, u = t ? t(o) : o;
    return a === !0 ? u : e && e(u, `${a}`) ? e(u, `${a}`) : typeof a == "object" ? Object.entries(a).map(([c, s]) => s === !1 || s === void 0 ? !1 : c !== "base" ? `${u}-${c}-${s}` : `${u}-${s}`) : `${u}-${a}`;
  });
}
function Je() {
  const { warn: n } = window.console;
  return window.console.warn = (...t) => {
    const e = [
      "Warning: Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component."
    ];
    t.forEach((r) => {
      e.some(
        (o) => (typeof r == "string" ? r : r.toString()).includes(o)
      ) || n(r);
    });
  }, n;
}
function ra(n, t, e = !1) {
  let r, o, i, a, u;
  const c = Je();
  try {
    [
      { onChange: r, onBlur: o },
      { touched: i, error: a, value: u }
      // eslint-disable-next-line react-hooks/rules-of-hooks
    ] = an(n);
  } catch (w) {
  } finally {
    window.console.warn = c;
  }
  const s = gt(() => zo(n), [n]), f = gt(() => Xo(i != null ? i : !1, a != null ? a : "", t) === "danger" ? "danger" : t, [i, a, t]), p = gt(() => !!i && !!a, [i, a]), b = gt(() => i && a ? !0 : e, [i, a, e]), y = gt(() => {
    switch (f) {
      case "warning":
        return "orange";
      case "danger":
        return "red";
      default:
        return;
    }
  }, [f]);
  return {
    fieldName: s,
    fieldColor: f,
    iconColor: y,
    fieldValue: u,
    fieldError: p,
    fieldTooltip: b,
    touched: i,
    error: a,
    onFieldChange: r,
    onFieldBlur: o
  };
}
function oa(n, t = { disableFormikValueSetter: !1, disableAllFormikSetters: !1 }) {
  if (t.disableAllFormikSetters || !n)
    return {
      formikTouched: !1,
      formikError: void 0,
      formikValue: void 0,
      formikSetValue: void 0,
      formikSetTouched: void 0
    };
  const e = Je();
  try {
    const r = sn(), { setValue: o, setTouched: i } = r.getFieldHelpers(n), { touched: a, error: u, value: c } = r.getFieldMeta(n);
    return {
      formikTouched: a,
      formikError: u,
      formikValue: t.disableFormikValueSetter ? void 0 : c,
      formikSetValue: t.disableFormikValueSetter ? void 0 : o,
      formikSetTouched: i
    };
  } catch (r) {
    return {
      formikTouched: !1,
      formikError: void 0,
      formikValue: void 0,
      formikSetValue: void 0,
      formikSetTouched: void 0
    };
  } finally {
    window.console.warn = e;
  }
}
export {
  ta as D,
  bt as O,
  G as X,
  oa as a,
  Vi as b,
  Gi as c,
  zi as d,
  ea as e,
  Ri as f,
  Wi as g,
  Kt as i,
  $i as j,
  Zi as k,
  Xi as l,
  Ui as m,
  Qi as n,
  Qe as o,
  na as s,
  ra as u,
  Ji as x,
  Ki as y
};
//# sourceMappingURL=formik-field-3c206abb.js.map
